// src/api/axiosClient.js
import axios from "axios";
import { getApiBaseUrl } from "../env/runtimeEnv";
import { auth } from "../config/firebase";

const axiosClient = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

// experience-backend now verifies this token server-side and derives the
// caller's uid from it - endpoints no longer trust a client-supplied userId.
axiosClient.interceptors.request.use(async (config) => {
  const user = auth?.currentUser;
  if (user) {
    const idToken = await user.getIdToken();
    config.headers.Authorization = `Bearer ${idToken}`;
  }
  return config;
});

export default axiosClient;
